import { Dispatch } from 'redux';
import ldIsEqual from 'lodash/isEqual';
import { actions } from '../../modules/Actions';
import { CooperationInfoList, getLinkedDataApi, LinkedDataApiRequest } from '../../../external/LinkedDataApi';
import { LOADING_TYPE } from '../../reducers/LoadingStatusReducer';
import { SORRY_MESSAGE_TYPE } from '../../reducers/SorryMessageReducer';
import { DEFAULT_PAGE_VIEW, DEFAULT_SCROLL_INFO } from '../../../Common';
import { FilterConditionLinkedDataState } from '../../reducers/FilterLinkedDataReducer';
import { reCalcFrom } from '../../../utils/LinkedDataUtils';

export const fetchLinkedDataResult = async (request: LinkedDataApiRequest, dispatch: Dispatch) => {
  dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.FILTER_LINKED_DATA));
  try {
    const { result, cooperationInfoList, summary, hit } = await getLinkedDataApi(request);
    dispatch(
      actions.updateLoadingStatus.done({
        params: LOADING_TYPE.FILTER_LINKED_DATA,
        result: result,
      })
    );
    dispatch(actions.linkedDataResult.updateTotalRecord(hit));
    dispatch(actions.linkedDataResult.updateSummaryInfo(summary));
    dispatch(actions.linkedDataResult.updateCooperationInfoList(cooperationInfoList));
  } catch (error) {
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    dispatch(
      actions.updateLoadingStatus.failed({
        params: LOADING_TYPE.FILTER_LINKED_DATA,
        error: {},
      })
    );
  }
};

export const updateLinkedDataResult = async (request: LinkedDataApiRequest, dispatch: Dispatch) => {
  const refresh = async () => {
    fetchLinkedDataResult(request, dispatch);
  };
  dispatch(actions.updateRefresh({ refresh }));
  refresh();
};

export const updateFilterSearchCondition = (filterData: FilterConditionLinkedDataState, dispatch: Dispatch) => {
  dispatch(actions.filterLinkedData.updateFilterCondition(filterData));
};

export const resetPaginationInfo = (dispatch: Dispatch) => {
  dispatch(actions.filterLinkedData.updateCurrentPage(DEFAULT_PAGE_VIEW.CURRENT_PAGE));
  dispatch(actions.filterLinkedData.updateApiIndexValue(DEFAULT_PAGE_VIEW.API_UPDATE_INDEX));
  dispatch(actions.filterLinkedData.updateScrollInfo(DEFAULT_SCROLL_INFO.FROM));
};

export const updateRefreshPaginationKey = (
  prevCooperationInfoList: CooperationInfoList[],
  cooperationInfoList: CooperationInfoList[],
  totalRecords: number,
  currentPage: number,
  dispatch: Dispatch
): number => {
  let reCalcFromValue = -1;
  if (ldIsEqual(prevCooperationInfoList, cooperationInfoList)) return reCalcFromValue;

  const newMaxPage = Math.ceil(totalRecords / 10);
  // このケースは、最後のページに要素が 1 つしかない場合で、それを削除する。
  if (currentPage > newMaxPage) {
    // 「currentPage > newMaxPage」は、データを削除し、商談一覧に戻るときに、currentPage が総ページ数より大きい です。 (つまり、最後のページがもう存在しない)
    // currentPageは現在のmaxPageで再度セットし、古いApiUpdateIndex (oldApiUpdateIndex) に従ってデータを戻すためにApiUpdateIndexを再度セットする必要がある。
    // ページに戻ると、ApiUpdateIndex が元の値に再度セットされるため。
    const newCurrentPage = newMaxPage;
    dispatch(actions.filterLinkedData.updateCurrentPage(newCurrentPage));
    if (!cooperationInfoList.length) {
      const apiUpdateIndex = newCurrentPage < DEFAULT_PAGE_VIEW.API_UPDATE_INDEX ? DEFAULT_PAGE_VIEW.API_UPDATE_INDEX : newCurrentPage;
      reCalcFromValue = reCalcFrom(newMaxPage);
      dispatch(actions.filterLinkedData.updateApiIndexValue(apiUpdateIndex));
    }
  }
  if (cooperationInfoList.length > 0 && currentPage === 0) {
    dispatch(actions.filterLinkedData.updateCurrentPage(DEFAULT_PAGE_VIEW.CURRENT_PAGE));
    dispatch(actions.filterLinkedData.updateApiIndexValue(DEFAULT_PAGE_VIEW.API_UPDATE_INDEX));
  }
  return reCalcFromValue;
};
